import * as React from "react";

const ArrowDownStrokeRegularIcon = ({ color = "#1f1f1f", ...props }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={12}
    height={12}
    viewBox="0 0 12 12"
    fill="none"
    {...props}
  >
    <path
      d="M6 1.875V10.125"
      stroke={color}
      style={{
        stroke: { color },
        strokeOpacity: 1
      }}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M2.625 6.75L6 10.125L9.375 6.75"
      stroke={color}
      style={{
        stroke: { color },
        strokeOpacity: 1
      }}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
export default ArrowDownStrokeRegularIcon;
